import React, { createContext, useState, useContext } from 'react';

const SourceContext = createContext();

export const useSource = () => useContext(SourceContext);

export const SourceProvider = ({ children }) => {
  const [activeSource, setActiveSource] = useState(null);
  const [hoveredSource, setHoveredSource] = useState(null);

  return (
    <SourceContext.Provider value={{ activeSource, setActiveSource, hoveredSource, setHoveredSource }}>
      {children}
    </SourceContext.Provider>
  );
};
